/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from "../ApiClient";

/**
* ICDCodes service.
* @module api/ICDCodesApi
* @version v0.3
*/
export default class ICDCodesApi {

    /**
    * Constructs a new ICDCodesApi. 
    * @alias module:api/ICDCodesApi
    * @class
    * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
    * default to {@link module:ApiClient#instanc
    e} if unspecified.
    */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }

    /**
     * Callback function to receive the result of the icdCodesGet operation.
     * @callback moduleapi/ICDCodesApi~icdCodesGetCallback
     * @param {String} error Error message, if any.
     * @param data This operation does not return a value.
     * @param {String} response The complete HTTP response.
     */

    /**
     * List All ICD Codes
     * &lt;h3&gt;   &amp;#128275; Access policy &lt;/h3&gt; &lt;p&gt;You can access this endpoint with the following token types:&lt;/p&gt; &lt;p&gt;&amp;#9989; M2M&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#10060; &lt;s&gt;Patient&lt;/s&gt;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;nbsp;&amp;#9989; Practitioner&lt;/p&gt; 
     * @param {Object} opts Optional parameters
     * @param {Array.<String>} opts.byValue Filter by value
     * @param {Array.<String>} opts.filters *Note: that the strings are stringified and encoded objects.*  Filter with operators.  | Field          | Operator | | ---------------| ---------| | value | eq, not_eq, matches, does_not_match, in, not_in |  Example query value: &#x60;&#x60;&#x60; { &#x27;field&#x27;: &#x27;value&#x27;, &#x27;operator&#x27;:&#x27;eq&#x27;, &#x27;value&#x27;:&#x27;expected_value&#x27;, } &#x60;&#x60;&#x60;  Example stringified and encoded query value: &#x60;&#x60;&#x60; %7B%22field%22%3A%22%23%7Bvalue%7D%22%2C%22operator%22%3A%22eq%22%2C%22value%22%3A%22expected_value%22%7D &#x60;&#x60;&#x60; 
     * @param {module:model/String} opts.filtersOperator Operator to chain filters
     * @param {Number} opts.page Page number (default to <.>)
     * @param {Number} opts.size Page size (default to <.>)
     * @param {Array.<module:model/String>} opts.sortBy Sort results
     * @param {module:api/ICDCodesApi~icdCodesGetCallback} callback The callback function, accepting three arguments: error, data, response
     */
    icdCodesGet(opts, callback) {
      opts = opts || {};
      let postBody = null;

      let pathParams = {
        
      };
      let queryParams = {
        'by_value': this.apiClient.buildCollectionParam(opts['byValue'], 'csv'),'filters[]': this.apiClient.buildCollectionParam(opts['filters'], 'multi'),'filters_operator': opts['filtersOperator'],'page': opts['page'],'size': opts['size'],'sort_by': this.apiClient.buildCollectionParam(opts['sortBy'], 'csv')
      };
      let headerParams = {
        
      };
      let formParams = {
        
      };

      let authNames = [];
      let contentTypes = [];
      let accepts = [];
      let returnType = null;

      return this.apiClient.callApi(
        '/icd_codes', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

}